import { render, staticRenderFns } from "./SortIcons.vue?vue&type=template&id=4265f820&"
import script from "./SortIcons.vue?vue&type=script&lang=js&"
export * from "./SortIcons.vue?vue&type=script&lang=js&"
import style0 from "./SortIcons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4265f820')) {
      api.createRecord('4265f820', component.options)
    } else {
      api.reload('4265f820', component.options)
    }
    module.hot.accept("./SortIcons.vue?vue&type=template&id=4265f820&", function () {
      api.rerender('4265f820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/BaseTable/SortIcons.vue"
export default component.exports